// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3b2dm","empty":"ModalGraph_empty__3tE45"};